var map = {
	"./desktop/component.js": 44696,
	"./heading/desktop/component.js": 56649,
	"./tags/desktop/component.js": 59456,
	"site/pages/special_feature_facilities/desktop/component.js": 44696,
	"site/pages/special_feature_facilities/heading/desktop/component.js": 56649,
	"site/pages/special_feature_facilities/tags/desktop/component.js": 59456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17184;